import { useQuery } from "@tanstack/react-query";
import { api } from "../../config";

function useGetStockMetrics(params, enabl) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/stock/metrics`, {params});
            return res.data;
        },
        queryKey: ['stock-metrics', params.channel, params.search, params.startDate, params.endDate, /* params.local, */ params.page, params.limit], // local comentado - filtro desabilitado
        enabled: enabl,
        retry: false,
        refetchOnWindowFocus: false
    });
}

export {
    useGetStockMetrics
}